import React from "react";
import { useState } from "react";
import { db, ref, set, push, remove, update } from "config/Firebase";
import Alert from "utils/Alert";
import { useData } from "context/DataContext";
import { useEffect } from "react";

const Category = () => {
  const [category, setCategory] = useState("");
  const [categorySelect, setCategorySelect] = useState({
    categoryKey: "",
    categoryName: "",
  });
  const [projectsIdOfCategory, setProjectsIdOfCategory] = useState([]);
  const [alert, setAlert] = useState({ open: false, msg: "", type: "" });
  const [submitting, setSubmitting] = useState(false);
  const { categoriesData, data } = useData();

  const handleCHange = (e) => {
    setCategory(e.target.value);
  };

  const updateFunction = (dbRef, dataObj) => {
    update(ref(db, dbRef), dataObj)
      .then((res) => {
        setSubmitting(false);
        setAlert({
          open: true,
          msg: "Data updated successfully.",
          type: "success",
        });
      })
      .catch((err) => {
        setSubmitting(false);
        setAlert({ open: true, msg: "Something went wrong!", type: "error" });
      });
  };

  const handleAddCategory = (e) => {
    e.preventDefault();
    setSubmitting(true);
    // if new category add
    if (!categorySelect.categoryKey.length > 0) {
      push(ref(db, "category/"), {
        category: category,
      })
        .then(() => {
          // setModal(false)
          setSubmitting(false);
          setCategory("");
          setAlert({
            open: true,
            msg: "Data Save successfully.",
            type: "success",
          });
        })
        .catch((err) => {
          console.log(err);
          // setModal(false)
          setSubmitting(false);
          setAlert({ open: true, msg: "Something went wrong!", type: "error" });
        });
    }
    // if category update
    else {
      const catObj = {
        category: category,
      };
      // if category used in any project
      if (projectsIdOfCategory.length > 0) {
        setSubmitting(false);
        updateFunction(`category/${categorySelect.categoryKey}`, catObj);
        projectsIdOfCategory.forEach((val) => {
          // console.log(val);
          updateFunction(`projects/${val.id}`, catObj);
        });
        setCategory("");
        setCategorySelect({ categoryKey: "", categoryName: "" });
      }
      // run if category is not used in any single project
      else {
        updateFunction(`category/${categorySelect.categoryKey}`, catObj);
        setCategory("");
        setCategorySelect({ categoryKey: "", categoryName: "" });
      }
    }
  };

  useEffect(() => {
    // console.log(categoriesData)
    return () => {
      setCategory("");
      setCategorySelect({ categoryKey: "", categoryName: "" });
      setProjectsIdOfCategory([]);
    };
  }, [categoriesData, data]);
  const handleDelete = (e) => {
    const categoryUsed = data.filter((val) => val.categories.includes(e.category) );
    // console.log(categoryUsed,e)
    if (!categoryUsed.length > 0) {
      remove(ref(db, `category/${e.id}`))
        .then((res) => {
          setAlert({
            open: true,
            msg: "Data Deleted successfully.",
            type: "success",
          });
        })
        .catch((err) => {
          setAlert({ open: true, msg: "Something went wrong!", type: "error" });
        });
    } else {
      setAlert({
        open: true,
        msg: "can't delete becuase this category used in projects!",
        type: "success",
      });
    }
  };

  const handleEdit = (event) => {
    // console.log(event)
    setCategorySelect({ categoryKey: event.id, categoryName: event.category });
    const filterProjects = data.filter(
      (val) => val.categories.includes(event.category) 
      // === event.category
    );
    
    setProjectsIdOfCategory(filterProjects);
    setCategory(event.category);
    console.log(filterProjects)
  };

  const handleBackAddCategory = () => {
    setCategory("");
    setCategorySelect({ categoryKey: "", categoryName: "" });
  };

  return (
    <div>
      <div>
        <h2>Categories</h2>
        <div>
          <br />
          <br />
          <form className="" onSubmit={handleAddCategory}>
            <input
              type="text"
              value={category}
              placeholder="Category"
              onChange={handleCHange}
              required
            />
            <br />
            <br />
            <div className="cs_row">
              {categorySelect.categoryKey.length > 0 ? (
                <button onClick={handleBackAddCategory}>Cancel</button>
              ) : null}
              <button type="submit" disabled={submitting}>
                {/* {categoryId?
            } */}
                {categorySelect.categoryKey
                  ? "Update Category"
                  : submitting
                  ? "Loading..."
                  : "Add Category"}
              </button>
            </div>
          </form>
          <br /> <br />
          <div className="categoryLsit">
            <ul>
              {categoriesData.length
                ? categoriesData.map((val) => (
                    <li
                      key={val.id}
                      className="cs_row align-items-center justify-content-between"
                    >
                      <p>{val.category}</p>
                      <div className="cs_row">
                        <button onClick={() => handleDelete(val)}>
                          &#10060;
                        </button>{" "}
                        <button onClick={() => handleEdit(val)}>&#9998;</button>
                      </div>
                    </li>
                  ))
                : null}
            </ul>
          </div>
        </div>
      </div>
      <Alert data={alert} setAlert={setAlert} />
    </div>
  );
};

export default Category;
